<template>

  <div>
    <date-picker 
      ref="date"
      :value="value"
      @input="change"
      :lang="lang"
      :placeholder="placeholder"
      :width="width"
      :popupStyle="popupStyle || {left: 0}"
      :format="format"
      @panel-change="handlePanelChange">
      </date-picker>
  </div>
  
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'Date',
  components: {
    DatePicker
  },
  props: {
    'value': {
      type: String,
      default: null
    },
    'placeholder': {
      type: String,
      default: function () {
        return this.$t('Select a date')
      }
    },
    'width': {
      type: String,
      default: '100%'
    },
    'popupStyle': {
      type: Object,
      default: null
    },
    'initialSelect': {
      type: String,
      default: null
    }
  },
  data () {
    return {
      lang: this.$i18n.locale.toLowerCase(),
      format: this.$t('date_format')
    }
  },
  methods: {
    change (value) {
      if (this.value) {
        value = moment(value).set({
          hour: moment(this.value).format('H'),
          minute: moment(this.value).format('m'),
          second: moment(this.value).format('s')
        })
      }
      this.$emit('input', value.toISOString())
    },
    handlePanelChange (panel, oldPanel) {
      if (this.initialSelect === 'year' && oldPanel === 'NONE') {
        this.$refs.date.$children[0].panel = 'YEAR'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/Date.vue